<form [formGroup]="form" *ngIf="defaultValues" class="pt-3 fs-5 needs-validation ng-untouched ng-pristine ng-invalid">
  <div class="border-0 pt-5">
    <h3 class="card-title align-items-start flex-column">
      <span class="card-label fw-bolder fs-3 mb-1">
        {{ "WIZARD.ADDRESS_DATA" | translate }}
      </span>
    </h3>
  </div>

  <div class="my-6 row">
    <label class=" col-lg-5 align-self-lg-center ">
      <span class="required">{{ "WIZARD.NIP" | translate }}</span>
    </label>
    <div class="col-lg-7">
      <input type="text" name="companyNIP" class="form-control form-control-lg form-control-solid"
        formControlName="companyNIP"/>
      <div *ngIf="form.get('companyNIP')?.touched">
        <app-inline-message
          *ngIf="isTouchedAndHasError(form, 'companyNIP', ['required', 'minlength', 'maxlength'])"
          [message]="'WIZARD.VALIDATION.NIP_REQUIRED' | translate"
        ></app-inline-message>
      </div>
    </div>
  </div>
  <div class="my-6 row">
    <label class=" col-lg-5 align-self-lg-center">
      <span class="required">{{ "WIZARD.COMPANY_NAME" | translate }}</span>
    </label>
    <div class="col-lg-7">
      <input
        name="companyName"
        class="form-control form-control-lg form-control-solid"
        formControlName="companyName"
      />
      <div *ngIf="form.get('companyName')?.touched">
        <app-inline-message
          *ngIf="form.get('companyName')?.hasError('required') && !form.get('companyName')?.hasError('minlength')"
          [message]="'WIZARD.VALIDATION.COMPANY_NAME_REQUIRED' | translate"
        ></app-inline-message>
        <app-inline-message
          *ngIf="form.get('companyName')?.hasError('minlength')"
          [message]="'COMMON.VALIDATION.MIN_LENGTH' | translate:{min: COMPANY_NAME_MIN}"
        ></app-inline-message>
        <app-inline-message
          *ngIf="form.get('companyName')?.hasError('maxlength')"
          [message]="'COMMON.VALIDATION.MAX_LENGTH' | translate:{max: ACCOUNT_NAME_MAX}"
        ></app-inline-message>
      </div>
    </div>
  </div>

  <div class="d-none">
    <div *ngIf="form.get('name')?.touched">
      <app-inline-message
        *ngIf="form.get('name')?.hasError('required')"
        [message]="'WIZARD.VALIDATION.NAME_REQUIRED' | translate"
      ></app-inline-message>
      <app-inline-message
        *ngIf="form.get('name')?.hasError('minlength')"
        [message]="'COMMON.VALIDATION.MIN_LENGTH' | translate:{min: COMPANY_NAME_MIN}"
      ></app-inline-message>
    </div>
  </div>
  <div formGroupName="address">
    <div class="my-6 row">
      <label class=" col-lg-5 align-self-lg-center  required">
        {{ "WIZARD.COUNTRY" | translate }}
      </label>
      <div class="col-lg-7">
        <select name="country" class="form-select form-select-lg form-select-solid" formControlName="country">
          <option
            *ngFor="let country of countriesService.countries$ | async"
            [value]="country.code">{{country.label}}</option>
        </select>
        <div *ngIf="form.get('address.country')?.touched">
          <app-inline-message
            *ngIf="form.get('address.country')?.hasError('required')"
            [message]="'WIZARD.VALIDATION.COUNTRY_REQUIRED' | translate"
          ></app-inline-message>
        </div>
      </div>
    </div>
    <div class="my-6 row">
      <label class=" col-lg-5 align-self-lg-center  required">
        {{ "WIZARD.STREET" | translate }}
      </label>
      <div class="col-lg-7 row pe-0">
        <div class="col-lg-9 pe-0 mb-1">
          <input class="form-control form-control-lg form-control-solid" formControlName="street"
            placeholder="{{'WIZARD.STREET_PLACEHOLDER'|translate}}"/>        <div *ngIf="form.get('address.street')?.touched">
          <app-inline-message
            *ngIf="isTouchedAndHasError(form, 'address.street', ['required', 'minlength', 'maxlength'])"
            [message]="'WIZARD.VALIDATION.STREET_REQUIRED' | translate"
          ></app-inline-message>
        </div>
        </div>
        <div class="col-lg-3 pe-0">
          <input class="form-control form-control-lg form-control-solid" formControlName="houseNumber"
            placeholder="{{'WIZARD.HOUSE_NUMBER_PLACEHOLDER'|translate}}"/>
          <div *ngIf="form.get('address.houseNumber')?.touched">
            <app-inline-message
              *ngIf="isTouchedAndHasError(form, 'address.houseNumber', ['required', 'minlength', 'maxlength'])"
              [message]="'WIZARD.VALIDATION.HOUSE_NUMBER_REQUIRED' | translate"
            ></app-inline-message>
          </div>
        </div>
      </div>
    </div>
    <div class="my-6 row">
      <label class=" col-lg-5 align-self-lg-center ">
        {{ "WIZARD.APARTMENT" | translate }}
      </label>
      <div class="col-lg-2">
        <input class="form-control form-control-lg form-control-solid" formControlName="apartmentNumber"
        placeholder="{{'WIZARD.APARTMENT_PLACEHOLDER'|translate}}"/>
      </div>
    </div>

    <div class="my-6 row">
      <label class=" col-lg-5 align-self-lg-center  required">
        {{ "WIZARD.POSTAL_CODE" | translate }}
      </label>
      <div class="col-lg-3">
        <input class="form-control form-control-lg form-control-solid" formControlName="postalCode"
          placeholder="{{'WIZARD.POSTAL_CODE_PLACEHOLDER'|translate}}"/>
        <div *ngIf="form.get('address.postalCode')?.touched">
          <app-inline-message
            *ngIf="isTouchedAndHasError(form, 'address.postalCode', ['required', 'minlength', 'maxlength'])"
            [message]="'WIZARD.VALIDATION.POSTAL_CODE_REQUIRED' | translate"
          ></app-inline-message>
        </div>
      </div>
    </div>

    <div class="my-6 row">
      <label class=" col-lg-5 align-self-lg-center  required">
        {{ "WIZARD.CITY" | translate }}
      </label>
      <div class="col-lg-7">
        <input class="form-control form-control-lg form-control-solid" formControlName="city"
          placeholder="{{'WIZARD.CITY_PLACEHOLDER'|translate}}"/>
        <div *ngIf="form.get('address.city')?.touched">
          <app-inline-message
            *ngIf="isTouchedAndHasError(form, 'address.city', ['required', 'minlength', 'maxlength'])"
            [message]="'WIZARD.VALIDATION.CITY_REQUIRED' | translate"
          ></app-inline-message>
        </div>
      </div>
    </div>
  </div>

  <div class="separator mb-8"></div>

  <h3 class="card-title align-items-start flex-column">
    <span class="card-label fw-bolder fs-3 mb-1">
      {{ "WIZARD.CONTACT_DATA" | translate }}
    </span>
  </h3>

  <div class="my-6 row">
    <label class=" col-lg-5 align-self-lg-center  required">
      {{ "WIZARD.PHONE" | translate }}
    </label>
    <div class="col-lg-7">
      <input name="mobilePhone" class="form-control form-control-lg form-control-solid"
        formControlName="mobilePhone"/>
      <div *ngIf="form.get('mobilePhone')?.touched">
        <app-inline-message
          *ngIf="isTouchedAndHasError(form, 'mobilePhone', ['required', 'minlength', 'maxlength'])"
          [message]="'WIZARD.VALIDATION.PHONE_REQUIRED' | translate"
        ></app-inline-message>
      </div>
    </div>
  </div>
  <div class="my-6 row">
    <label class=" col-lg-5 align-self-lg-center  required">
      {{ "WIZARD.EMAIL" | translate }}
    </label>
    <div class="col-lg-7">
      <input name="email" class="form-control form-control-lg form-control-solid" formControlName="email"/>
      <div *ngIf="form.get('email')?.touched">
        <app-inline-message
          *ngIf="isTouchedAndHasError(form, 'email', ['required', 'email'])"
          [message]="'WIZARD.VALIDATION.EMAIL_REQUIRED' | translate"
        ></app-inline-message>
      </div>
    </div>
  </div>

  <div class="separator mb-8"></div>

  <div class="row">
    <div class="col-lg-11 fv-row mb-6">
      <label class="fw-bold form-label">{{ "WIZARD.OTHER_CORRESPONDENCE_ADDRESS" | translate }}</label>
    </div>
    <div class="col-lg-1 fv-row mb-6">
      <label class="form-check form-check-custom form-check-solid form-switch">
        <input class="form-check-input" type="checkbox" formControlName="showCorrespondenceAddress"
          name="showCorrespondenceAddress" (change)="onChangeOtherAddress()"/>
      </label>
    </div>
  </div>
  <div formGroupName="correspondenceAddress" *ngIf="showCorrespondenceAddress">
    <div class="fv-row mb-6">
      <label class="required">{{ "WIZARD.COUNTRY" | translate }}</label>
      <select name="country" class="form-select form-select-lg form-select-solid" formControlName="country">
        <option
          *ngFor="let country of countriesService.countries$ | async"
          [value]="country.code">{{country.label}}</option>
      </select>          <div *ngIf="form.get('correspondenceAddress.country')?.touched">
            <app-inline-message
              *ngIf="isTouchedAndHasError(form, 'correspondenceAddress.country', ['required'])"
              [message]="'WIZARD.VALIDATION.COUNTRY_REQUIRED' | translate"
            ></app-inline-message>
          </div>
    </div>
    <div class="row">
      <div class="col-lg-9 fv-row">
        <label class="required">{{ "WIZARD.STREET" | translate }}</label>
        <input class="form-control form-control-lg form-control-solid" formControlName="street"
          placeholder="{{'WIZARD.STREET_PLACEHOLDER'|translate}}"/>
        <div *ngIf="form.get('correspondenceAddress.street')?.touched">
          <app-inline-message
            *ngIf="isTouchedAndHasError(form, 'correspondenceAddress.street', ['required', 'minlength', 'maxlength'])"
            [message]="'WIZARD.VALIDATION.STREET_REQUIRED' | translate"
          ></app-inline-message>
        </div>
      </div>
      <div class="col-lg-3 fv-row mt-7">
        <input class="form-control form-control-lg form-control-solid" formControlName="houseNumber"
          placeholder="{{'WIZARD.HOUSE_NUMBER_PLACEHOLDER'|translate}}"/>
        <div *ngIf="form.get('correspondenceAddress.houseNumber')?.touched">
          <app-inline-message
            *ngIf="isTouchedAndHasError(form, 'correspondenceAddress.houseNumber', ['required', 'minlength', 'maxlength'])"
            [message]="'WIZARD.VALIDATION.HOUSE_NUMBER_REQUIRED' | translate"
          ></app-inline-message>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-2 fv-row mb-6">
        <label>{{ "WIZARD.APARTMENT" | translate }}</label>
        <input class="form-control form-control-lg form-control-solid" formControlName="apartmentNumber"
               placeholder="{{'WIZARD.APARTMENT_PLACEHOLDER'|translate}}"/>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 fv-row mb-6">
        <label class="required">{{ "WIZARD.POSTAL_CODE" | translate }}</label>
        <input class="form-control form-control-lg form-control-solid" formControlName="postalCode"
          placeholder="{{'WIZARD.POSTAL_CODE_PLACEHOLDER'|translate}}"/>
        <div *ngIf="form.get('correspondenceAddress.postalCode')?.touched">
          <app-inline-message
            *ngIf="isTouchedAndHasError(form, 'correspondenceAddress.postalCode', ['required', 'minlength', 'maxlength'])"
            [message]="'WIZARD.VALIDATION.POSTAL_CODE_REQUIRED' | translate"
          ></app-inline-message>
        </div>
      </div>
      <div class="col-lg-9 fv-row mb-6">
        <label class="required">{{ "WIZARD.CITY" | translate }}</label>
        <input class="form-control form-control-lg form-control-solid" formControlName="city"
          placeholder="{{'WIZARD.CITY_PLACEHOLDER'|translate}}"/>
        <div *ngIf="form.get('correspondenceAddress.city')?.touched">
          <app-inline-message
            *ngIf="isTouchedAndHasError(form, 'correspondenceAddress.city', ['required', 'minlength', 'maxlength'])"
            [message]="'WIZARD.VALIDATION.CITY_REQUIRED' | translate"
          ></app-inline-message>
        </div>
      </div>
    </div>
  </div>
</form>
